<template>
  <div class="student-exam-detail">
    <!-- <div class="exam-detail-header">
      <div class="header-left">
        <el-button type="text" icon="el-icon-arrow-left" @click="goBack">返回</el-button>
        <h3>{{ examInfo.examName || '考试详情' }}</h3>
      </div>
      <div class="header-right">
        <el-tag :type="getExamStatusTag(examInfo.status)" size="medium">
          {{ getExamStatusText(examInfo.status) }}
        </el-tag>
      </div>
    </div> -->

    <!-- 考试基本信息 -->
    <div class="exam-basic-info" v-if="examInfo.examName">
      <el-row :gutter="20">
        <el-col :span="8">
          <div class="info-item">
            <div class="info-label">考试名称</div>
            <div class="info-value">{{ examInfo.examName }}</div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="info-item">
            <div class="info-label">考试时间</div>
            <div class="info-value">{{ formatExamTime(examInfo.startTime, examInfo.endTime) }}</div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="info-item">
            <div class="info-label">考试时长</div>
            <div class="info-value">{{ examInfo.examDuration }} 分钟</div>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20" style="margin-top: 15px;">
        <el-col :span="8">
          <div class="info-item">
            <div class="info-label">总分</div>
            <div class="info-value">{{ examInfo.totalScore }} 分</div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="info-item">
            <div class="info-label">及格分</div>
            <div class="info-value">{{ examInfo.passScore }} 分</div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="info-item">
            <div class="info-label">试卷套数</div>
            <div class="info-value">{{ examInfo.paperCount }} 套</div>
          </div>
        </el-col>
      </el-row>
      <div v-if="examInfo.examDescription" class="exam-description">
        <div class="info-label">考试描述</div>
        <div class="info-value">{{ examInfo.examDescription }}</div>
      </div>
    </div>

    <!-- 学生信息 -->
    <div class="student-info" v-if="studentInfo.studentName">
      <h4><i class="el-icon-user"></i> 学生信息</h4>
      <el-row :gutter="20">
        <el-col :span="6">
          <div class="student-avatar">
            <img v-if="studentInfo.avatar" :src="studentInfo.avatar" :alt="studentInfo.studentName" />
            <i v-else class="el-icon-user"></i>
          </div>
        </el-col>
        <el-col :span="18">
          <div class="student-details">
            <div class="student-name">{{ studentInfo.studentName }} ({{ studentInfo.studentNum }})</div>
            <div class="student-meta">
              <span><i class="el-icon-school"></i> {{ studentInfo.schoolName }}</span>
              <span><i class="el-icon-user"></i> {{ studentInfo.grade }} {{ studentInfo.className }}</span>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <!-- 考试结果 - 根据权限显示 -->
    <div class="exam-result" v-if="examInfo.finalScore !== undefined && examInfo.allowViewScore">
      <h4><i class="el-icon-medal"></i> 考试结果</h4>
      <div class="result-summary">
        <div class="score-display">
          <div class="score-number">{{ examInfo.finalScore }}</div>
          <div class="score-total">/ {{ examInfo.totalScore }}</div>
          <div class="score-percentage">{{ getScorePercentage(examInfo.finalScore, examInfo.totalScore) }}%</div>
        </div>
        <div class="result-status">
          <el-tag :type="getScoreTagType(examInfo.finalScore, examInfo.totalScore)" size="large">
            {{ getScoreText(examInfo.finalScore, examInfo.totalScore) }}
          </el-tag>
        </div>
      </div>
    </div>

    <!-- 权限提示 -->
    <el-alert
      v-if="examInfo.allowViewScore === 0"
      title="提示"
      type="info"
      :closable="false"
      style="margin-bottom: 20px;"
    >
      教师未开放查看成绩权限
    </el-alert>

    <!-- 主要内容区域：左右分栏布局 -->
    <div class="main-content">
      <!-- 左侧：试卷图片 - 根据权限显示 -->
      <div class="left-panel">
        <div v-if="paperImages.length > 0 && examInfo.allowViewPaper">
          <h4><i class="el-icon-picture"></i> 试卷图片</h4>

          <!-- 图片显示区域 - 完全参照教师端批阅页面 -->
          <div class="image-container" ref="imageContainer">
            <!-- 图片切换控制 -->
            <div class="image-controls" v-if="paperImages.length > 1">
              <el-button-group>
                <el-button size="mini" @click="prevImage" :disabled="currentImageIndex === 0">
                  <i class="el-icon-arrow-left"></i> 上一张
                </el-button>
                <el-button size="mini" disabled>
                  {{ currentImageIndex + 1 }} / {{ paperImages.length }}
                  <span v-if="paperImages.length > 0 && getImageAnnotationCount(currentImageIndex) > 0" class="annotation-count">
                    ({{ getImageAnnotationCount(currentImageIndex) }}个标注)
                  </span>
                </el-button>
                <el-button size="mini" @click="nextImage" :disabled="currentImageIndex === paperImages.length - 1">
                  下一张 <i class="el-icon-arrow-right"></i>
                </el-button>
              </el-button-group>
            </div>

            <!-- 缩放控制 -->
            <div class="zoom-controls">
              <el-button-group>
                <el-button size="mini" @click="zoomIn">放大</el-button>
                <el-button size="mini" @click="zoomOut">缩小</el-button>
                <el-button size="mini" @click="resetZoom">重置</el-button>
              </el-button-group>
            </div>

            <div class="image-wrapper" :style="{ transform: `scale(${zoomLevel})` }">
              <img
                :src="getImageUrl(currentImageUrl)"
                alt="试卷图片"
                ref="paperImage"
                @load="handleImageLoad"
                @click="showImagePreview"
                style="cursor: pointer;"
              />

              <!-- 标注层 - 不跟随图像缩放，通过坐标计算保持同步 -->
              <div class="annotation-layer">
                <!-- 调试信息 -->
                <div v-if="currentImageAnnotations.length === 0" style="position: absolute; top: 10px; left: 10px; background: rgba(255,0,0,0.8); color: white; padding: 5px; border-radius: 4px; font-size: 12px;">
                  当前图片无标注 (imageIndex: {{ currentImageIndex }}, 总标注: {{ annotations.length }})
                </div>

                 <div
                   v-for="annotation in currentImageAnnotations"
                   :key="annotation.id"
                   class="annotation"
                   :style="{
                     left: getAdjustedAnnotationPosition(annotation, currentImageIndex).x + 'px',
                     top: getAdjustedAnnotationPosition(annotation, currentImageIndex).y + 'px',
                     color: annotation.color,
                     fontSize: annotation.size + 'px'
                   }"
                   :title="`${annotation.content} (原始: x:${annotation.x}, y:${annotation.y}, 调整后: x:${getAdjustedAnnotationPosition(annotation, currentImageIndex).x}, y:${getAdjustedAnnotationPosition(annotation, currentImageIndex).y})`"
                 >
                   {{ getAnnotationSymbol(annotation.type, annotation.content) }}
                 </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="no-images">
          <i class="el-icon-picture-outline"></i>
          <p>暂无试卷图片</p>
        </div>
      </div>

      <!-- 右侧：题目详情 -->
      <div class="right-panel">
        <div class="question-details-section" v-if="questions.length > 0">
          <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 15px;">
            <h4 style="margin: 0;"><i class="el-icon-edit"></i> 题目详情</h4>
            <!-- 导入错题按钮 -->
            <el-button
              v-if="examInfo.allowRecordMistake === 1"
              type="primary"
              size="small"
              icon="el-icon-document-add"
              @click="importWrongQuestions"
            >
              导入错题到错题本
            </el-button>
          </div>
      <div class="questions-list">
        <div
          v-for="(question, index) in questions"
          :key="question.questionId || index"
          class="question-item"
        >
          <div class="question-header">
            <div class="question-number">第{{ index + 1 }}题</div>
            <div class="question-score">
              <span class="score-got">{{ question.answerScore || 0 }}</span>
              <span class="score-total">/ {{ question.questionScore || 0 }} 分</span>
            </div>
            <div class="question-type">
              <el-tag :type="getQuestionTypeTag(question.questionType)" size="mini">
                {{ getQuestionTypeName(question.questionType) }}
              </el-tag>
            </div>
          </div>

          <div class="question-content">
            <div class="question-text">{{ question.questionContent || `题目ID: ${question.questionId}` }}</div>

            <!-- 题目图片 -->
            <div v-if="question.questionImage" class="question-image">
                  <img :src="getImageUrl(question.questionImage)" :alt="`题目图片`" :data-original-src="question.questionImage" @error="handleImageError" />
                  <!-- <div class="debug-info" style="font-size: 12px; color: #666; margin-top: 5px;">
                    题目图片URL: {{ question.questionImage }}
                  </div> -->
            </div>

            <!-- 选择题选项 -->
            <div v-if="question.questionType === 1 && question.questionOptions" class="question-options">
              <div
                v-for="(option, optIndex) in parseOptions(question.questionOptions)"
                :key="optIndex"
                class="option-item"
                :class="{
                  'correct': isCorrectOption(option, question.correctAnswer),
                  'selected': isSelectedOption(option, question.answerId),
                  'wrong': isSelectedOption(option, question.answerId) && !isCorrectOption(option, question.correctAnswer)
                }"
              >
                <span class="option-label">{{ String.fromCharCode(65 + optIndex) }}.</span>
                <span class="option-text">{{ option }}</span>
                <i v-if="isCorrectOption(option, question.correctAnswer)" class="el-icon-check correct-icon"></i>
                <i v-if="isSelectedOption(option, question.answerId) && !isCorrectOption(option, question.correctAnswer)" class="el-icon-close wrong-icon"></i>
              </div>
            </div>

            <!-- 学生答案信息 - 根据权限显示 -->
            <div class="answer-info" v-if="examInfo.allowViewAnswerDetail !== 0">
              <div class="answer-item">
                <span class="answer-label">学生答案：</span>
                <span class="answer-text">{{ question.answerContent || question.answerId || '未作答' }}</span>
              </div>
              <div class="answer-item">
                <span class="answer-label">标准答案：</span>
                <span class="answer-text">{{ question.correctAnswer || '暂无' }}</span>
              </div>
              <div class="answer-item">
                <span class="answer-label">是否正确：</span>
                <el-tag :type="question.isRight ? 'success' : 'danger'" size="mini">
                  {{ question.isRight ? '正确' : '错误' }}
                </el-tag>
              </div>
              <div class="answer-item">
                <span class="answer-label">得分：</span>
                <span class="answer-text">{{ question.answerScore || 0 }} / {{ question.questionScore || 0 }} 分</span>
              </div>
              <div class="answer-item">
                <span class="answer-label">答题时间：</span>
                <span class="answer-text">{{ question.answerTime || 0 }} 秒</span>
              </div>
              <div v-if="question.questionAnalysis" class="answer-item">
                <span class="answer-label">题目解析：</span>
                <div class="answer-text analysis-text">{{ question.questionAnalysis }}</div>
              </div>
              <div v-if="question.questionKnowledge" class="answer-item">
                <span class="answer-label">知识点：</span>
                <span class="answer-text">{{ question.questionKnowledge }}</span>
              </div>
              <div v-if="question.questionDifficulty" class="answer-item">
                <span class="answer-label">题目难度：</span>
                <span class="answer-text">{{ question.questionDifficulty }}</span>
              </div>
              <div v-if="question.teacherComment" class="answer-item">
                <span class="answer-label">教师评语：</span>
                <div class="answer-text comment-text">{{ question.teacherComment }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
        <div v-else class="no-questions">
          <i class="el-icon-document"></i>
          <p>暂无题目详情</p>
          </div>
        </div>
      </div>

    <!-- 加载状态 -->
    <div v-if="loading" class="loading-container" v-loading="loading" element-loading-text="正在加载考试详情...">
    </div>

    <!-- 空状态 -->
    <div v-if="!loading && !examInfo.examName" class="empty-state">
      <i class="el-icon-document"></i>
      <p>暂无考试详情</p>
    </div>

    <!-- 图片预览模态框 -->
    <el-dialog
      :title="`试卷图片预览 - 第${previewImageIndex + 1}张`"
      :visible.sync="imagePreviewVisible"
      width="100%"
      top="0"
      :before-close="closeImagePreview"
      class="image-preview-dialog"
      :modal="false"
      :close-on-click-modal="true"
      :close-on-press-escape="true"
    >
      <div class="image-preview-container">
        <div class="preview-controls">
          <el-button-group v-if="paperImages.length > 1">
            <el-button size="small" @click="prevPreviewImage" :disabled="previewImageIndex === 0">
              <i class="el-icon-arrow-left"></i> 上一张
            </el-button>
            <el-button size="small" disabled>
              {{ previewImageIndex + 1 }} / {{ paperImages.length }}
            </el-button>
            <el-button size="small" @click="nextPreviewImage" :disabled="previewImageIndex === paperImages.length - 1">
              下一张 <i class="el-icon-arrow-right"></i>
            </el-button>
          </el-button-group>
      </div>

        <div class="preview-image-wrapper" @wheel="handlePreviewWheel" ref="previewImageWrapper">
          <div class="preview-image-container" :style="{ transform: `scale(${previewZoomLevel})` }">
            <img
              :src="getImageUrl(paperImages[previewImageIndex])"
              :alt="`试卷图片 ${previewImageIndex + 1}`"
              class="preview-image"
              @load="handlePreviewImageLoad"
              ref="previewImage"
            />

            <!-- 预览模式标注层 -->
            <div class="preview-annotation-layer">
              <div
                v-for="annotation in getPreviewImageAnnotations()"
                :key="annotation.id"
                class="preview-annotation"
                :style="{
                  left: getPreviewAnnotationPosition(annotation).x + 'px',
                  top: getPreviewAnnotationPosition(annotation).y + 'px',
                  color: annotation.color,
                  fontSize: annotation.size + 'px'
                }"
                :title="`${annotation.content} (原始: x:${annotation.x}, y:${annotation.y})`"
              >
                {{ getAnnotationSymbol(annotation.type, annotation.content) }}
              </div>
            </div>
          </div>
    </div>

        <div class="preview-info">
          <p>点击图片外部区域或按ESC键关闭预览</p>
    </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { examApi } from '@/api/exam'

export default {
  name: 'StudentExamDetail',
  props: {
    examId: {
      type: [String, Number],
      required: true
    },
    courseId: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      loading: false,
      examInfo: {},
      studentInfo: {},
      studentId: null, // 学生ID
      questions: [],
      paperImages: [],
      imagePreviewVisible: false,
      // 批注相关
      annotations: [],
      imageAnnotations: {}, // 按图片索引分组的标注
      currentImageAnnotations: [],
      currentImageIndex: 0,
      zoomLevel: 1,
      refreshingAnnotations: false,

      // 当前显示的图片
      currentImageUrl: '',

      // 图片预览相关
      imagePreviewVisible: false,
      previewImageIndex: 0,
      previewZoomLevel: 1
    }
  },
  mounted() {
    // 从localStorage获取学生ID
    this.getStudentIdFromStorage()
    this.loadExamDetail()

    // 添加窗口大小变化监听
    window.addEventListener('resize', this.handleWindowResize)
  },

  beforeDestroy() {
    // 移除窗口大小变化监听
    window.removeEventListener('resize', this.handleWindowResize)
  },
  methods: {
    // 从localStorage获取学生ID
    getStudentIdFromStorage() {
      try {
        // 方法1：从localStorage的userInfo中获取
        const userInfoStr = localStorage.getItem('userInfo')
        console.log('StudentExamDetail - localStorage中的userInfo字符串:', userInfoStr)

        if (userInfoStr) {
          const userInfo = JSON.parse(userInfoStr)
          console.log('StudentExamDetail - 解析后的userInfo对象:', userInfo)
          console.log('StudentExamDetail - userInfo的所有属性:', Object.keys(userInfo))

          // 尝试不同的可能属性名，优先使用data.studentId
          this.studentId = userInfo.data?.studentId || userInfo.studentId || userInfo.userId || userInfo.id || userInfo.user_id
          console.log('StudentExamDetail - 从userInfo获取的学生ID:', this.studentId)
          console.log('StudentExamDetail - userInfo.data.studentId:', userInfo.data?.studentId)
          console.log('StudentExamDetail - userInfo.id:', userInfo.id)
        }

        // 方法2：如果userInfo中没有，尝试从token中解析
        if (!this.studentId) {
          const token = localStorage.getItem('token')
          console.log('StudentExamDetail - localStorage中的token:', token)

          if (token) {
            try {
              // 解析JWT token
              const parts = token.split('.')
              if (parts.length === 3) {
                const payload = JSON.parse(atob(parts[1].replace(/-/g, '+').replace(/_/g, '/')))
                console.log('StudentExamDetail - 从token解析的payload:', payload)

                // 尝试从payload中获取用户ID
                this.studentId = payload.userId || payload.id || payload.sub || payload.user_id
                console.log('StudentExamDetail - 从token获取的学生ID:', this.studentId)
              }
            } catch (tokenError) {
              console.error('StudentExamDetail - 解析token失败:', tokenError)
            }
          }
        }

        // 方法3：如果还是没有，尝试从Vuex store获取
        if (!this.studentId) {
          console.log('StudentExamDetail - 尝试从Vuex store获取用户信息')
          // 这里可以访问 this.$store.state.user
        }

        console.log('StudentExamDetail - 最终获取的学生ID:', this.studentId)

        if (!this.studentId) {
          console.warn('StudentExamDetail - 无法获取学生ID')
        }
      } catch (error) {
        console.error('StudentExamDetail - 获取学生ID失败:', error)
      }
    },

    // 加载考试详情
    async loadExamDetail() {
      this.loading = true
      try {
        console.log('StudentExamDetail - 开始加载考试详情')
        console.log('StudentExamDetail - examId:', this.examId)
        console.log('StudentExamDetail - courseId:', this.courseId)
        console.log('StudentExamDetail - studentId:', this.studentId)

        // 获取学生考试详情
        const response = await examApi.getStudentExamDetail(this.examId, this.studentId)
        console.log('StudentExamDetail - API响应:', response)

        if (response && response.code === 1) {
          const data = response.data
          console.log('StudentExamDetail - 考试详情数据:', data)
          console.log('StudentExamDetail - 考试详情数据类型:', typeof data)
          console.log('StudentExamDetail - 考试详情数据的所有属性:', Object.keys(data))

          // 检查是否有权限错误
          if (data.error) {
            this.$message.error(data.error)
            this.loading = false
            return
          }

          // 设置考试基本信息
          this.examInfo = {
            examName: data.examName,
            examDescription: data.examDescription,
            examDuration: data.duration,
            startTime: data.examStartTime,
            endTime: data.examEndTime,
            totalScore: data.totalScore,
            passScore: data.passScore,
            paperCount: data.paperCount,
            status: data.examStatus,
            finalScore: data.finalScore,
            // 权限信息
            allowViewScore: data.allowViewScore,
            allowViewPaper: data.allowViewPaper,
            allowRecordMistake: data.allowRecordMistake,
            allowViewAnswerDetail: data.allowViewAnswerDetail
          }

          // 设置学生信息
          this.studentInfo = {
            studentId: data.studentId,
            studentName: data.studentName,
            studentNum: data.studentNum,
            schoolName: data.schoolName,
            grade: data.grade,
            className: data.className,
            avatar: data.avatar
          }

          console.log('StudentExamDetail - 学生信息:', this.studentInfo)
          console.log('StudentExamDetail - 学生ID:', this.studentInfo.studentId)

          // 设置题目列表
          this.questions = data.questions || []
          console.log('StudentExamDetail - 题目列表:', this.questions)

          // 设置试卷图片 - 处理逗号分隔的图片URL字符串
          if (data.paperImages && data.paperImages.length > 0) {
            this.paperImages = data.paperImages.flatMap(imageStr => {
              if (typeof imageStr === 'string' && imageStr.includes(',')) {
                // 如果是逗号分隔的字符串，分割成数组
                return imageStr.split(',').map(url => url.trim()).filter(url => url)
              } else {
                // 如果是单独的URL，直接返回
                return [imageStr]
              }
            })
            console.log('StudentExamDetail - 试卷图片数量:', this.paperImages.length)
            console.log('StudentExamDetail - 试卷图片URLs:', this.paperImages)
          } else {
            this.paperImages = []
            console.log('StudentExamDetail - 没有试卷图片数据')
          }

          // 设置当前显示的图片
          if (this.paperImages.length > 0) {
            this.currentImageIndex = 0
            this.currentImageUrl = this.paperImages[0]
          }

          // 加载批注信息
          console.log('StudentExamDetail - 开始加载批注信息')
          await this.loadAnnotations()
          console.log('StudentExamDetail - 批注信息加载完成')

          // 设置当前图片的标注
          if (this.paperImages.length > 0) {
            console.log(`StudentExamDetail - 开始设置初始图片${this.currentImageIndex}的标注`)
            console.log(`StudentExamDetail - 当前所有标注数据:`, this.annotations)
            this.loadImageAnnotations(this.currentImageIndex)
            console.log(`StudentExamDetail - 初始图片${this.currentImageIndex}的标注数量:`, this.currentImageAnnotations.length)
            console.log(`StudentExamDetail - 初始图片${this.currentImageIndex}的标注详情:`, this.currentImageAnnotations)

            // 强制更新视图
            this.$nextTick(() => {
              console.log(`StudentExamDetail - 视图更新后，currentImageAnnotations:`, this.currentImageAnnotations)
            })
          }

          console.log('StudentExamDetail - 数据设置完成')
          console.log('StudentExamDetail - 考试信息:', this.examInfo)
          console.log('StudentExamDetail - 学生信息:', this.studentInfo)
          console.log('StudentExamDetail - 题目数量:', this.questions.length)
          console.log('StudentExamDetail - 图片数量:', this.paperImages.length)
        } else {
          console.error('StudentExamDetail - API返回失败:', response)
          this.$message.error(response?.msg || '获取考试详情失败')
        }
      } catch (error) {
        console.error('StudentExamDetail - 加载考试详情失败:', error)
        console.error('StudentExamDetail - 错误详情:', error.response)
        this.$message.error('加载考试详情失败')
      } finally {
        console.log('StudentExamDetail - 设置loading为false')
        console.log('StudentExamDetail - 最终状态检查:')
        console.log('  - loading:', this.loading)
        console.log('  - examInfo.examName:', this.examInfo.examName)
        console.log('  - paperImages.length:', this.paperImages.length)
        console.log('  - annotations.length:', this.annotations.length)
        console.log('  - imageAnnotations:', this.imageAnnotations)
        this.loading = false
      }
    },

    // 返回上一页
    goBack() {
      this.$emit('close')
    },

    // 获取考试状态标签
    getExamStatusTag(status) {
      const statusMap = {
        1: 'info', // 草稿
        2: 'primary', // 已发布
        3: 'warning', // 进行中
        4: 'success', // 已结束
        5: 'info' // 已归档
      }
      return statusMap[status] || 'default'
    },

    // 获取考试状态文本
    getExamStatusText(status) {
      const statusMap = {
        1: '草稿',
        2: '已发布',
        3: '进行中',
        4: '已结束',
        5: '已归档'
      }
      return statusMap[status] || '未知状态'
    },

    // 格式化考试时间
    formatExamTime(startTime, endTime) {
      if (!startTime || !endTime) return '暂无'

      const start = new Date(startTime)
      const end = new Date(endTime)

      const startStr = start.toLocaleString('zh-CN', {
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      })

      const endStr = end.toLocaleString('zh-CN', {
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      })

      return `${startStr} - ${endStr}`
    },

    // 获取分数百分比
    getScorePercentage(score, totalScore) {
      if (!score || !totalScore) return 0
      return Math.round((score / totalScore) * 100)
    },

    // 获取分数标签类型
    getScoreTagType(score, totalScore) {
      if (score === null || score === undefined) return 'info'

      const percentage = (score / totalScore) * 100
      if (percentage >= 90) return 'success'
      if (percentage >= 80) return 'primary'
      if (percentage >= 60) return 'warning'
      return 'danger'
    },

    // 获取分数文本
    getScoreText(score, totalScore) {
      if (score === null || score === undefined) return '未评分'
      const percentage = Math.round((score / totalScore) * 100)
      return `${score}/${totalScore} (${percentage}%)`
    },

    // 获取题目类型名称
    getQuestionTypeName(type) {
      const typeMap = {
        1: '单选题',
        2: '多选题',
        3: '判断题',
        4: '简答题'
      }
      return typeMap[type] || '未知类型'
    },

    // 获取题目类型标签样式
    getQuestionTypeTag(type) {
      const tagMap = {
        1: 'primary',
        2: 'success',
        3: 'warning',
        4: 'info'
      }
      return tagMap[type] || 'default'
    },

    // 解析选项字符串
    parseOptions(optionsStr) {
      if (!optionsStr) return []
      try {
        // 尝试解析JSON格式的选项
        if (optionsStr.startsWith('[') || optionsStr.startsWith('{')) {
          return JSON.parse(optionsStr)
        }
        // 解析逗号分隔的选项
        return optionsStr.split(',').map(opt => opt.trim()).filter(opt => opt)
      } catch (e) {
        console.warn('解析选项失败:', e)
        return []
      }
    },

    // 判断选项是否正确
    isCorrectOption(option, correctAnswer) {
      if (!correctAnswer) return false
      return correctAnswer.includes(option) || correctAnswer === option
    },

    // 判断选项是否被选中
    isSelectedOption(option, studentAnswer) {
      if (!studentAnswer) return false
      return studentAnswer.includes(option) || studentAnswer === option
    },

    // 图片错误处理
    handleImageError(event) {
      console.error('StudentExamDetail - 图片加载失败:', event.target.src)
      console.error('StudentExamDetail - 原始URL:', event.target.getAttribute('data-original-src'))
    },

    // 获取完整的图片URL
    getImageUrl(imageUrl) {
      if (!imageUrl) return ''

      // 如果已经是完整URL，直接返回
      if (imageUrl.startsWith('http://') || imageUrl.startsWith('https://')) {
        return imageUrl
      }

      // 如果是API预览接口，使用前端API基础URL
      if (imageUrl.startsWith('/api/file/preview')) {
        // 移除开头的 /api，因为 VUE_APP_BASE_API 已经包含了 /api
        const pathWithoutApi = imageUrl.substring(4) // 移除 '/api'
        return process.env.VUE_APP_BASE_API + pathWithoutApi
      }

      // 如果是MinIO路径，使用MinIO端口（与教师端保持一致）
      if (imageUrl.startsWith('/exam-papers/')) {
        return `http://localhost:9000${imageUrl}`
      }

      // 其他MinIO路径也使用MinIO端口
      if (imageUrl.startsWith('/question-info/') || imageUrl.startsWith('/course-cover/') || imageUrl.startsWith('/course-resources/')) {
        return `http://localhost:9000${imageUrl}`
      }

      // 其他情况使用API端口
      return `http://localhost:8080${imageUrl}`
    },

    // 导入错题到错题本
    async importWrongQuestions() {
      try {
        // 获取错题列表（答错的题目）
        const wrongQuestions = this.questions.filter(q => q.isRight === 0 || (q.isRight === false))

        if (wrongQuestions.length === 0) {
          this.$message.info('没有错题可导入')
          return
        }

        await this.$confirm(
          `确定要将${wrongQuestions.length}道错题导入到错题本吗？`,
          '确认导入',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'info'
          }
        )

        // TODO: 调用导入错题API
        // 这里需要实现导入错题到错题本的功能
        // await wrongQuestionApi.importExamWrongQuestions(this.examId, this.studentId, wrongQuestions)

        this.$message.success(`成功导入${wrongQuestions.length}道错题到错题本`)
      } catch (error) {
        if (error !== 'cancel') {
          console.error('导入错题失败:', error)
          this.$message.error('导入错题失败')
        }
      }
    },

    // 加载批注信息
    async loadAnnotations() {
      try {
        if (!this.studentInfo.studentId) {
          console.warn('StudentExamDetail - 学生ID不存在，无法加载批注信息')
          return
        }

        console.log('StudentExamDetail - 开始加载批注信息，examId:', this.examId, 'studentId:', this.studentInfo.studentId)

        const response = await examApi.getGradingAnnotations(this.examId, this.studentInfo.studentId)
        console.log('StudentExamDetail - 批注API响应:', response)

        if (response && response.code === 1) {
          this.annotations = response.data || []
          console.log('StudentExamDetail - 加载批注信息成功:', this.annotations.length)
          console.log('StudentExamDetail - 批注数据:', this.annotations)

          // 按图片索引分组标注信息
          this.imageAnnotations = {}
          for (const annotation of this.annotations) {
            const imageIndex = annotation.imageIndex
            if (imageIndex !== null && imageIndex !== undefined) {
              if (!this.imageAnnotations[imageIndex]) {
                this.imageAnnotations[imageIndex] = []
              }
              this.imageAnnotations[imageIndex].push(annotation)
            }
          }

          console.log('StudentExamDetail - 标注信息分组完成:', this.imageAnnotations)

          // 检查每张图片的批注数量
          console.log('StudentExamDetail - 批注数据加载完成，检查每张图片的批注数量:')
          for (let i = 0; i < this.paperImages.length; i++) {
            const count = this.getImageAnnotationCount(i)
            console.log(`StudentExamDetail - 图片${i}的批注数量: ${count}`)
          }
        } else {
          console.warn('StudentExamDetail - 批注API响应异常:', response)
        }
      } catch (error) {
        console.error('StudentExamDetail - 加载批注信息失败:', error)
        this.annotations = []
      }
    },

    // 获取指定图片的批注
    getImageAnnotations(imageIndex) {
      console.log(`StudentExamDetail - 获取图片${imageIndex}的批注，总批注数:`, this.annotations.length)
      console.log(`StudentExamDetail - 所有批注数据:`, this.annotations)

      const imageAnnotations = this.annotations.filter(annotation => {
        console.log(`StudentExamDetail - 批注详情:`, {
          id: annotation.id,
          type: annotation.type,
          content: annotation.content,
          imageIndex: annotation.imageIndex,
          questionId: annotation.questionId,
          x: annotation.x,
          y: annotation.y
        })
        console.log(`StudentExamDetail - 批注imageIndex: ${annotation.imageIndex} (${typeof annotation.imageIndex}), 目标imageIndex: ${imageIndex} (${typeof imageIndex})`)

        // 如果imageIndex为null或undefined，这些是题目标注，不属于任何图片
        if (annotation.imageIndex === null || annotation.imageIndex === undefined) {
          console.log(`StudentExamDetail - 批注imageIndex为null/undefined，这是题目标注，不属于图片`)
          return false
        }

        // 确保类型一致进行比较
        const matches = Number(annotation.imageIndex) === Number(imageIndex)
        console.log(`StudentExamDetail - 批注匹配结果: ${matches}`)
        return matches
      })

      console.log(`StudentExamDetail - 图片${imageIndex}的批注数量:`, imageAnnotations.length)
      console.log(`StudentExamDetail - 过滤后的批注:`, imageAnnotations)
      return imageAnnotations
    },

    // 获取图片批注数量
    getImageAnnotationCount(imageIndex) {
      return this.imageAnnotations[imageIndex] ? this.imageAnnotations[imageIndex].length : 0
    },

    // 处理窗口大小变化
    handleWindowResize() {
      console.log('StudentExamDetail - 窗口大小变化，重新计算标注位置')
      // 延迟执行，等待DOM更新
      setTimeout(() => {
        this.recalculateAnnotationPositions()
      }, 100)
    },

    // 重新计算标注位置
    recalculateAnnotationPositions() {
      if (this.currentImageAnnotations.length > 0) {
        console.log(`StudentExamDetail - 重新计算第${this.currentImageIndex + 1}张图片的标注位置`)

        // 检查图像是否已加载
        const img = this.$refs.paperImage
        if (img && img.naturalWidth > 0) {
          console.log(`StudentExamDetail - 图像尺寸: ${img.naturalWidth}x${img.naturalHeight}, 显示尺寸: ${img.offsetWidth}x${img.offsetHeight}`)

          // 触发Vue的响应式更新
          this.currentImageAnnotations = [...this.currentImageAnnotations]

          console.log(`StudentExamDetail - 标注位置重新计算完成，共${this.currentImageAnnotations.length}个标注`)
        } else {
          console.log(`StudentExamDetail - 图像尚未加载完成，延迟重新计算`)
          // 如果图像还没加载完成，延迟重试
          setTimeout(() => {
            this.recalculateAnnotationPositions()
          }, 200)
        }
      }
    },

    // 放大
    zoomIn() {
      this.zoomLevel = Math.min(this.zoomLevel + 0.2, 3)
      console.log(`StudentExamDetail - 放大到: ${this.zoomLevel}`)
      // 缩放后重新计算标注位置
      this.$nextTick(() => {
        this.recalculateAnnotationPositions()
      })
    },

    // 缩小
    zoomOut() {
      this.zoomLevel = Math.max(this.zoomLevel - 0.2, 0.5)
      console.log(`StudentExamDetail - 缩小到: ${this.zoomLevel}`)
      // 缩放后重新计算标注位置
      this.$nextTick(() => {
        this.recalculateAnnotationPositions()
      })
    },

    // 重置缩放
    resetZoom() {
      this.zoomLevel = 1
      console.log(`StudentExamDetail - 重置缩放到: ${this.zoomLevel}`)
      // 重置后重新计算标注位置
      this.$nextTick(() => {
        this.recalculateAnnotationPositions()
      })
    },

    // 获取调整后的标注位置（处理第一张图片的偏移）
    getAdjustedAnnotationPosition(annotation, imageIndex) {
      // 由于image-wrapper已经应用了transform: scale()，标注层也在其中
      // 所以坐标不需要乘以zoomLevel，只需要应用基础缩放比例
      let adjustedX, adjustedY

      if (imageIndex === 0) {
        // 第一张图片需要特殊调整
        const img = this.$refs.paperImage
        if (img && img.naturalWidth > 0 && img.naturalHeight > 0) {
          const scaleX = img.offsetWidth / img.naturalWidth
          const scaleY = img.offsetHeight / img.naturalHeight

          // 只应用基础缩放比例，zoomLevel由CSS transform处理
          adjustedX = annotation.x * scaleX
          adjustedY = annotation.y * scaleY

          console.log(`StudentExamDetail - 第一张图片缩放比例: x=${scaleX.toFixed(3)}, y=${scaleY.toFixed(3)}, zoomLevel=${this.zoomLevel}`)
        } else {
          // 如果无法获取图像信息，使用默认调整
          adjustedX = annotation.x - 200
          adjustedY = annotation.y - 120
        }

        console.log(`StudentExamDetail - 第一张图片标注${annotation.id}调整: 原始(${annotation.x}, ${annotation.y}) -> 调整后(${adjustedX.toFixed(1)}, ${adjustedY.toFixed(1)})`)
      } else {
        // 其他图片使用原始坐标，CSS transform会自动处理缩放
        adjustedX = annotation.x
        adjustedY = annotation.y

        console.log(`StudentExamDetail - 第${imageIndex + 1}张图片标注: 原始(${annotation.x}, ${annotation.y})`)
      }

      return {
        x: adjustedX,
        y: adjustedY
      }
    },

    // 图像加载完成处理
    handleImageLoad() {
      if (this.$refs.paperImage) {
        const img = this.$refs.paperImage
        const container = this.$refs.imageContainer

        console.log('StudentExamDetail - 图像加载完成:')
        console.log('  - 原始尺寸:', img.naturalWidth, 'x', img.naturalHeight)
        console.log('  - 显示尺寸:', img.offsetWidth, 'x', img.offsetHeight)
        console.log('  - 缩放级别:', this.zoomLevel)
        console.log('  - 图像位置:', img.offsetLeft, img.offsetTop)
        console.log('  - 容器尺寸:', container ? container.offsetWidth + 'x' + container.offsetHeight : 'N/A')
        console.log('  - 容器padding:', container ? getComputedStyle(container).padding : 'N/A')
        console.log('  - 当前图片索引:', this.currentImageIndex)
        console.log('  - 当前标注数量:', this.currentImageAnnotations.length)

        // 输出每个标注的坐标和调整后的坐标
        this.currentImageAnnotations.forEach((annotation, index) => {
          const adjusted = this.getAdjustedAnnotationPosition(annotation, this.currentImageIndex)
          console.log(`  - 标注${index + 1} (ID:${annotation.id}):`, {
            原始坐标: `(${annotation.x}, ${annotation.y})`,
            调整后坐标: `(${adjusted.x}, ${adjusted.y})`,
            type: annotation.type,
            content: annotation.content
          })
        })

        // 图像加载完成后重新计算标注位置
        this.$nextTick(() => {
          this.recalculateAnnotationPositions()
        })
      }
    },

    // 获取批注符号
    getAnnotationSymbol(type, content) {
      console.log(`StudentExamDetail - 批注类型: ${type} (${typeof type}), 内容: ${content}`)
      const symbols = {
        'correct': '✓',
        'partial': '△',
        'wrong': '✗',
        'text': content || '文字'
      }
      const symbol = symbols[type] || '?'
      console.log(`StudentExamDetail - 批注符号: ${symbol}`)
      return symbol
    },

    // 缩放控制
    zoomIn() {
      this.zoomLevel = Math.min(this.zoomLevel * 1.2, 3)
    },

    zoomOut() {
      this.zoomLevel = Math.max(this.zoomLevel / 1.2, 0.5)
    },

    resetZoom() {
      this.zoomLevel = 1
    },

    // 刷新标注信息
    async refreshAnnotations() {
      this.refreshingAnnotations = true
      try {
        console.log('StudentExamDetail - 手动刷新标注信息')
        await this.loadAnnotations()

        // 更新当前图片的标注
        if (this.paperImages.length > 0) {
          this.loadImageAnnotations(this.currentImageIndex)
          console.log(`StudentExamDetail - 刷新后图片${this.currentImageIndex}的标注数量:`, this.currentImageAnnotations.length)
        }

        this.$message.success('标注信息已刷新')
      } catch (error) {
        console.error('StudentExamDetail - 刷新标注失败:', error)
        this.$message.error('刷新标注失败')
      } finally {
        this.refreshingAnnotations = false
      }
    },

    // 加载指定图片的标注信息 - 参照教师端
    loadImageAnnotations(imageIndex) {
      if (this.imageAnnotations[imageIndex]) {
        this.currentImageAnnotations = [...this.imageAnnotations[imageIndex]]
        console.log(`StudentExamDetail - 加载第${imageIndex + 1}张图片的标注信息:`, this.currentImageAnnotations)
      } else {
        this.currentImageAnnotations = []
        console.log(`StudentExamDetail - 第${imageIndex + 1}张图片暂无标注信息`)
      }
    },

    // 图片导航方法 - 参照教师端
    prevImage() {
      if (this.currentImageIndex > 0) {
        this.currentImageIndex--
        this.currentImageUrl = this.paperImages[this.currentImageIndex]
        this.loadImageAnnotations(this.currentImageIndex)
        console.log(`StudentExamDetail - 切换到上一张图片: ${this.currentImageIndex}`)

        // 等待图像加载完成后再计算标注位置
        this.waitForImageLoadAndRecalculate()
      }
    },

    nextImage() {
      if (this.currentImageIndex < this.paperImages.length - 1) {
        this.currentImageIndex++
        this.currentImageUrl = this.paperImages[this.currentImageIndex]
        this.loadImageAnnotations(this.currentImageIndex)
        console.log(`StudentExamDetail - 切换到下一张图片: ${this.currentImageIndex}`)

        // 等待图像加载完成后再计算标注位置
        this.waitForImageLoadAndRecalculate()
      }
    },

    // 等待图像加载完成并重新计算标注位置
    waitForImageLoadAndRecalculate() {
      // 先等待DOM更新
      this.$nextTick(() => {
        // 再等待图像加载完成
        const img = this.$refs.paperImage
        if (img) {
          if (img.complete && img.naturalWidth > 0) {
            // 图像已经加载完成
            console.log(`StudentExamDetail - 图像已加载完成，重新计算标注位置`)
            this.recalculateAnnotationPositions()
          } else {
            // 图像还在加载，等待加载完成事件
            console.log(`StudentExamDetail - 等待图像加载完成...`)
            const onLoad = () => {
              console.log(`StudentExamDetail - 图像加载完成，重新计算标注位置`)
              this.recalculateAnnotationPositions()
              img.removeEventListener('load', onLoad)
            }
            img.addEventListener('load', onLoad)
          }
        } else {
          // 如果无法获取图像引用，延迟重试
          setTimeout(() => {
            this.waitForImageLoadAndRecalculate()
          }, 100)
        }
      })
    },

    // 图片预览相关方法
    showImagePreview() {
      this.previewImageIndex = this.currentImageIndex
      this.previewZoomLevel = 1 // 重置缩放级别
      this.imagePreviewVisible = true
      console.log(`StudentExamDetail - 显示图片预览: 第${this.previewImageIndex + 1}张`)
    },

    closeImagePreview() {
      this.imagePreviewVisible = false
      this.previewZoomLevel = 1 // 重置缩放级别
      console.log(`StudentExamDetail - 关闭图片预览`)
    },

    prevPreviewImage() {
      if (this.previewImageIndex > 0) {
        this.previewImageIndex--
        this.previewZoomLevel = 1 // 切换图片时重置缩放级别
        console.log(`StudentExamDetail - 预览切换到上一张图片: ${this.previewImageIndex}`)
      }
    },

    nextPreviewImage() {
      if (this.previewImageIndex < this.paperImages.length - 1) {
        this.previewImageIndex++
        this.previewZoomLevel = 1 // 切换图片时重置缩放级别
        console.log(`StudentExamDetail - 预览切换到下一张图片: ${this.previewImageIndex}`)
      }
    },

    handlePreviewImageLoad() {
      console.log(`StudentExamDetail - 预览图片加载完成: 第${this.previewImageIndex + 1}张`)
      // 图片加载完成后，强制重新计算标注位置
      this.$nextTick(() => {
        console.log(`StudentExamDetail - 预览图片加载完成，重新计算标注位置`)
      })
    },

    // 获取预览图片的标注
    getPreviewImageAnnotations() {
      if (this.imageAnnotations[this.previewImageIndex]) {
        console.log(`StudentExamDetail - 预览第${this.previewImageIndex + 1}张图片的标注数量:`, this.imageAnnotations[this.previewImageIndex].length)
        return this.imageAnnotations[this.previewImageIndex]
      }
      console.log(`StudentExamDetail - 预览第${this.previewImageIndex + 1}张图片无标注`)
      return []
    },

    // 计算预览模式下的标注位置
    getPreviewAnnotationPosition(annotation) {
      // 直接使用原始坐标，让CSS的transform: scale()统一处理缩放
      return {
        x: annotation.x,
        y: annotation.y
      }
    },

    // 预览滚轮缩放
    handlePreviewWheel(event) {
      event.preventDefault()

      const delta = event.deltaY
      const zoomStep = 0.1

      if (delta < 0) {
        // 向上滚动，放大
        this.previewZoomLevel = Math.min(this.previewZoomLevel + zoomStep, 5)
      } else {
        // 向下滚动，缩小
        this.previewZoomLevel = Math.max(this.previewZoomLevel - zoomStep, 0.1)
      }

      console.log(`StudentExamDetail - 预览缩放级别: ${this.previewZoomLevel.toFixed(2)}`)

      // 缩放后强制重新计算标注位置
      this.$nextTick(() => {
        console.log(`StudentExamDetail - 预览缩放后重新计算标注位置`)
        // 触发Vue的响应式更新
        this.$forceUpdate()
      })
    }
  }
}
</script>

<style scoped>
.student-exam-detail {
  padding: 20px;
  background: #f5f5f5;
  min-height: 100vh;
}

/* 头部样式 */
.exam-detail-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  background: white;
  border-radius: 8px;
  margin-bottom: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.header-left {
  display: flex;
  align-items: center;
}

.header-left h3 {
  margin: 0 0 0 15px;
  color: #303133;
  font-size: 20px;
}

/* 考试基本信息 */
.exam-basic-info {
  background: white;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.info-item {
  margin-bottom: 10px;
}

.info-label {
  font-size: 14px;
  color: #909399;
  margin-bottom: 5px;
}

.info-value {
  font-size: 16px;
  color: #303133;
  font-weight: 500;
}

.exam-description {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #ebeef5;
}

/* 学生信息 */
.student-info {
  background: white;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.student-info h4 {
  margin: 0 0 15px 0;
  color: #303133;
  font-size: 16px;
  display: flex;
  align-items: center;
}

.student-info h4 i {
  margin-right: 8px;
  color: #409EFF;
}

.student-avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f0f0f0;
}

.student-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.student-avatar i {
  font-size: 24px;
  color: #909399;
}

.student-name {
  font-size: 18px;
  font-weight: bold;
  color: #303133;
  margin-bottom: 8px;
}

.student-meta {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.student-meta span {
  font-size: 14px;
  color: #606266;
  display: flex;
  align-items: center;
}

.student-meta i {
  margin-right: 5px;
  color: #409EFF;
}

/* 考试结果 */
.exam-result {
  background: white;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.exam-result h4 {
  margin: 0 0 15px 0;
  color: #303133;
  font-size: 16px;
  display: flex;
  align-items: center;
}

.exam-result h4 i {
  margin-right: 8px;
  color: #409EFF;
}

.result-summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.score-display {
  display: flex;
  align-items: baseline;
  gap: 5px;
}

.score-number {
  font-size: 48px;
  font-weight: bold;
  color: #409EFF;
}

.score-total {
  font-size: 24px;
  color: #909399;
}

.score-percentage {
  font-size: 16px;
  color: #606266;
  margin-left: 10px;
}

/* 题目详情 */
.question-details {
  background: white;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.question-details h4 {
  margin: 0 0 20px 0;
  color: #303133;
  font-size: 16px;
  display: flex;
  align-items: center;
}

.question-details h4 i {
  margin-right: 8px;
  color: #409EFF;
}

.question-item {
  border: 1px solid #ebeef5;
  border-radius: 8px;
  margin-bottom: 20px;
  overflow: hidden;
}

.question-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  background: #f8f9fa;
  border-bottom: 1px solid #ebeef5;
}

.question-number {
  font-size: 16px;
  font-weight: bold;
  color: #303133;
}

.question-score {
  display: flex;
  align-items: baseline;
  gap: 3px;
}

.score-got {
  font-size: 18px;
  font-weight: bold;
  color: #67c23a;
}

.score-total {
  font-size: 14px;
  color: #909399;
}

.question-content {
  padding: 20px;
}

.question-text {
  font-size: 16px;
  color: #303133;
  line-height: 1.6;
  margin-bottom: 15px;
}

/* 题目图片样式 */
.question-image {
  margin: 15px 0;
  text-align: center;
}

.question-image img {
  max-width: 100%;
  max-height: 300px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* 选项样式 */
.question-options {
  margin: 15px 0;
}

.option-item {
  display: flex;
  align-items: center;
  padding: 10px 15px;
  margin: 8px 0;
  border-radius: 6px;
  border: 1px solid #e4e7ed;
  background: #fff;
  transition: all 0.3s ease;
}

.option-item.correct {
  background: #f0f9ff;
  border-color: #67c23a;
}

.option-item.selected {
  background: #fff7e6;
  border-color: #e6a23c;
}

.option-item.wrong {
  background: #fef0f0;
  border-color: #f56c6c;
}

.option-label {
  font-weight: bold;
  margin-right: 10px;
  min-width: 20px;
}

.option-text {
  flex: 1;
}

.correct-icon {
  color: #67c23a;
  margin-left: 10px;
}

.wrong-icon {
  color: #f56c6c;
  margin-left: 10px;
}

/* 答案信息 */
.answer-info {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #ebeef5;
}

.answer-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 10px;
}

.answer-label {
  font-weight: bold;
  color: #606266;
  min-width: 80px;
  margin-right: 10px;
}

.answer-text {
  color: #303133;
  flex: 1;
}

/* 解析和评语样式 */
.analysis-text, .comment-text {
  background: #f8f9fa;
  padding: 12px;
  border-radius: 6px;
  border-left: 4px solid #409EFF;
  white-space: pre-wrap;
  line-height: 1.6;
}

/* 主要内容区域：左右分栏布局 */
.main-content {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
}

.left-panel {
  flex: 0 0 40%;
  min-width: 300px;
}

.right-panel {
  flex: 1;
  min-width: 0;
}

/* 试卷图片区域 */
.paper-images-section {
  background: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  height: fit-content;
  position: sticky;
  top: 20px;
}

.paper-images-section h4 {
  margin: 0 0 15px 0;
  color: #303133;
  font-size: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
}

.paper-images-section h4 i {
  margin-right: 8px;
  color: #409EFF;
}

.no-images {
  background: white;
  border-radius: 8px;
  padding: 40px 20px;
  text-align: center;
  color: #909399;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.no-images i {
  font-size: 48px;
  margin-bottom: 10px;
  color: #c0c4cc;
}

/* 题目详情区域 */
.question-details-section {
  background: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.question-details-section h4 {
  margin: 0 0 20px 0;
  color: #303133;
  font-size: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
}

.question-details-section h4 i {
  margin-right: 8px;
  color: #409EFF;
}

.no-questions {
  background: white;
  border-radius: 8px;
  padding: 40px 20px;
  text-align: center;
  color: #909399;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.no-questions i {
  font-size: 48px;
  margin-bottom: 10px;
  color: #c0c4cc;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .main-content {
    flex-direction: column;
  }

  .left-panel {
    flex: none;
    min-width: auto;
  }

  .paper-images-section {
    position: static;
  }

  .images-grid {
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  }
}

/* 试卷图片 */
.paper-images {
  background: white;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.paper-images h4 {
  margin: 0 0 20px 0;
  color: #303133;
  font-size: 16px;
  display: flex;
  align-items: center;
}

.paper-images h4 i {
  margin-right: 8px;
  color: #409EFF;
}

.images-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 15px;
}

/* 批注相关样式 */
.annotation-count {
  margin-left: 8px;
  color: #409EFF;
  font-weight: bold;
}

.image-preview-container {
  position: relative;
  max-height: 70vh;
  overflow: auto;
  text-align: center;
}

.preview-tools {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding: 10px;
  background: #f5f7fa;
  border-radius: 4px;
}

.zoom-level {
  font-size: 14px;
  color: #606266;
  font-weight: bold;
}

.image-container {
  flex: 1;
  overflow: auto;
  padding: 20px;
  text-align: center;
  position: relative;
}

.image-controls {
  position: absolute;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
  background: rgba(255, 255, 255, 0.9);
  padding: 8px;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.zoom-controls {
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 1000;
  background: rgba(255, 255, 255, 0.9);
  padding: 8px;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.image-wrapper {
  position: relative;
  display: inline-block;
  transition: transform 0.3s;
}

.image-wrapper img {
  max-width: 100%;
  height: auto;
  cursor: crosshair;
}

.annotation-layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

.annotation {
  position: absolute;
  pointer-events: auto;
  cursor: pointer;
  font-weight: bold;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
  transition: all 0.3s;
}

.annotation:hover {
  transform: scale(1.2);
}

.debug-info {
  position: absolute;
  top: 10px;
  left: 10px;
  background: rgba(255, 0, 0, 0.8);
  color: white;
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 12px;
  z-index: 2000;
}

.image-item {
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.3s ease;
}

.image-item:hover {
  transform: scale(1.05);
}

.image-item img {
  width: 100%;
  height: auto;
  max-height: 300px;
  object-fit: contain;
  background: #f5f5f5;
}

.image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.image-item:hover .image-overlay {
  opacity: 1;
}

.image-overlay i {
  color: white;
  font-size: 24px;
}

/* 图片预览 */
.image-preview-container {
  text-align: center;
}

.preview-image {
  max-width: 100%;
  max-height: 70vh;
  border-radius: 8px;
}

/* 加载和空状态 */
.loading-container {
  height: 200px;
}

.empty-state {
  text-align: center;
  padding: 60px 20px;
  color: #909399;
}

.empty-state i {
  font-size: 64px;
  margin-bottom: 20px;
  color: #c0c4cc;
}

.empty-state p {
  font-size: 16px;
  margin: 0;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .student-exam-detail {
    padding: 10px;
  }

  .exam-detail-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .result-summary {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }

  .images-grid {
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  }
}

/* 试卷图片标题样式 */
.left-panel h4 {
  margin: 0 0 15px 0;
  color: #303133;
  font-size: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
}

.left-panel h4 i {
  margin-right: 8px;
  color: #409EFF;
}

/* 图片预览模态框样式 */
.image-preview-dialog {
  margin: 0 !important;
  height: 100vh !important;
  max-height: 100vh !important;
}

.image-preview-dialog .el-dialog {
  margin: 0 !important;
  height: 100vh !important;
  max-height: 100vh !important;
  border-radius: 0 !important;
}

.image-preview-dialog .el-dialog__body {
  padding: 0;
  height: calc(100vh - 60px);
}

.image-preview-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  max-height: 100vh;
}

.preview-controls {
  padding: 15px;
  background: #f5f5f5;
  border-bottom: 1px solid #e4e7ed;
  text-align: center;
  flex-shrink: 0;
}

.preview-image-wrapper {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #000;
  overflow: hidden;
  position: relative;
  cursor: grab;
}

.preview-image-wrapper:active {
  cursor: grabbing;
}

.preview-image-container {
  position: relative;
  display: inline-block;
}

.preview-image {
  max-width: none;
  max-height: none;
  object-fit: contain;
  cursor: pointer;
  transition: transform 0.1s ease;
  display: block;
}

.preview-annotation-layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  transform-origin: top left;
}

.preview-annotation {
  position: absolute;
  pointer-events: auto;
  cursor: pointer;
  font-weight: bold;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
  transition: all 0.3s;
}

.preview-annotation:hover {
  transform: scale(1.2);
}

.preview-info {
  padding: 10px;
  background: #f5f5f5;
  border-top: 1px solid #e4e7ed;
  text-align: center;
  color: #666;
  font-size: 14px;
  flex-shrink: 0;
}
</style>
